<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    :persistent="persistentDialog"
  >
    <v-card>
      <v-toolbar dark :color="dialogColor" dense flat>
        <v-toolbar-title class="white--text">{{ $t(title) }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="text-center pa-6">

  <v-icon
    v-if="dialogIcon"
    :color="dialogIconColor"
    size="70"
    class="mb-4"
  >
    {{ dialogIcon }}
  </v-icon>

  <div
    v-if="message"
    class="secondary--text font-weight-bold"
    style="white-space: pre-line;"
  >
    {{ $t(message) }}
  </div>

</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>

        <!-- Confirm Button -->
        <v-btn
          v-if="!options.hideConfirm"
          :color="options.confirmColor || 'primary'"
          dark
          @click="agree"
        >
          {{ $t(options.confirmText || "CONFIRM") }}
        </v-btn>



        <!-- Extra Button (text-only, uses checkVar) -->
        <v-btn
          v-if="options.extraButtonText"
          color="secondary"
          @click.native="extraAction"
        >
          {{ $t(options.extraButtonText) }}
        </v-btn>

        <!-- Cancel Button -->
        <v-btn
          v-if="!options.hideCancel"
          :color="options.cancelColor"
          dark
          class="white--text"
          @click.native="cancel"
        >
          {{ $t(options.cancelText || 'CANCEL') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["persistentDialog"],
  name: "pr-confirmDialog",
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
     defaultOptions: {
    color: "primary",
    width: 470,
    zIndex: 200,

    type: "info",
    icon: null,

    confirmColor: "primary",
    confirmText: null,

    cancelColor: "darken3",
    cancelText: null,

    extraButtonText: null,
    checkVar: null,

    hideConfirm: false,
    hideCancel: false
  },
  options: {},
  }),
  computed: {
     dialogColor() {
    if (this.options.color)
      return this.options.color;

    switch (this.options.type) {
      case "warning":
        return "warning";

      case "error":
        return "error";

      case "success":
        return "success";

      default:
        return "primary";
    }
  },
  dialogIcon() {
    if (this.options.icon) return this.options.icon;

    switch (this.options.type) {
      case "warning":
        return "mdi-alert-outline";

      case "error":
        return "mdi-alert-circle";

      case "success":
        return "mdi-check-circle";

      default:
        return "mdi-information-outline";
    }
  },

  dialogIconColor() {
    switch (this.options.type) {
      case "warning":
        return "warning";

      case "error":
        return "error";

      case "success":
        return "success";

      default:
        return "primary";
    }
  }
},
  methods: {
    open(title, message, options = {}) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = {
            ...this.defaultOptions,
            ...options
          };
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      if (this.resolve) this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      if (this.resolve) this.resolve(false);
      this.dialog = false;
    },
    extraAction() {
      if (this.resolve) this.resolve(this.options.checkVar);
      this.dialog = false;
    }
  }
  ,created() {
  this.options = { ...this.defaultOptions };
},
};
</script>
